import { IHttpError } from './http.interface';

export function isInformationHttpCode(code: number): boolean {
    return /^1..$/.test(code.toString());
}

export function isSuccessHttpCode(code: number): boolean {
    return /^2..$/.test(code.toString());
}

export function isRedirectHttpCode(code: number): boolean {
    return /^3..$/.test(code.toString());
}

export function isSuccessRequest(code: number): boolean {
    return isInformationHttpCode(code) ||
        isSuccessHttpCode(code) ||
        isRedirectHttpCode(code);
}

export async function handleFetchResponse<T>(resp: Response): Promise<[ T, IHttpError? ]> {
    if (!isSuccessRequest(resp.status)) {
        return [ undefined, {
            code: resp.status,
            message: resp.statusText,
        } ] as [ T, IHttpError ];
    }

    return [ await resp.json() ] as [ T ];
}
